export default {
  DEEPLINK_FALLBACK: 'deeplink-fallback',
  SWORD_REDIRECT: 'sword_redirect',
  DOWNLOAD_LINK: 'download-link',
  INIT_PERSONIFY_HEALTH: 'personify-health-init',
  INIT_UHCHUB: 'uhchub-init',
  INIT_WEBMD_ONE: 'webmd-one-init',
  LANDING_PAGE: 'landing-page',
  LOGIN: 'login',
  PARTNER_SEARCH: 'partner-search',
  PASSWORD_RESET: 'password-reset',
  SAML_SSO_COMPLETED: 'saml-sso-completed',
  SAML_SSO_ERROR: 'saml-sso-error',
  SAML_SSO_INITIATED: 'saml-sso-initiated',
  SELECT_VERIFICATION_METHOD: 'select-verification-method',
  SIGN_UP: 'sign-up',
  SUBSCRIPTION: 'subscription',
  VERIFY_WITH_ELIGIBILITY_LIST: 'verify-with-eligibility-list',
  VERIFY_WITH_SOLERA: 'verify-with-solera',
  VERIFY_WITH_UHCHUB: 'verify-with-uhchub',
  VERIFY_WITH_UHCSTORE: 'verify-with-uhcstore',
  VERIFY_WITH_VOUCHER: 'verify-with-voucher',
  VERIFY_WITH_WEBMD_ONE: 'verify-with-webmd-one',
}
